import { SeoUser, TaxonomySeo } from '@thg-commerce/enterprise-network'

import { MetaRenderer, RendererTags } from '../MetaRenderer'
import {
  META_BINGEBOT_INDEX,
  META_GOOGLEBOT_INDEX,
  getRobotsMeta,
} from '../utils'
import { CategoryMetadataTransformer } from '../../../helpers/MetadataTransformer'

export type CategoryMetaNameType = {
  description?: string
  robots?: string
  googlebot?: string
  bingbot?: string
}

export type CategoryMetaLinkType = {
  canonical: string
}

export interface CategoryMetaRendererProps {
  seo?: TaxonomySeo | SeoUser | null
  canonicalUrl: string
}

export interface CategoryMetaTags extends Partial<RendererTags> {
  metaNameTags: CategoryMetaNameType
  linkTags: CategoryMetaLinkType
}

export interface PartialCategoryMetaTags
  extends Omit<CategoryMetaTags, 'metaNameTags' | 'linkTags'> {
  metaNameTags: Partial<CategoryMetaNameType>
  linkTags: Partial<CategoryMetaLinkType>
}

export const CategoryMetaRenderer = (props: CategoryMetaRendererProps) => {
  const categoryMetaTags: CategoryMetaTags = {
    metaNameTags: {
      robots:
        (props.seo?.metaRobotsNoindex &&
          props.seo?.metaRobotsNofollow &&
          getRobotsMeta(
            props.seo?.metaRobotsNoindex,
            props.seo?.metaRobotsNofollow,
          )) ||
        '',
    },
    linkTags: {
      canonical: props.canonicalUrl,
    },
  }

  if (props.seo?.metaDesc) {
    categoryMetaTags.metaNameTags.description = props.seo?.metaDesc
  }

  if (props.seo?.metaRobotsNoindex === 'index') {
    categoryMetaTags.metaNameTags.googlebot = META_GOOGLEBOT_INDEX
    categoryMetaTags.metaNameTags.bingbot = META_BINGEBOT_INDEX
  }

  return MetaRenderer(
    CategoryMetadataTransformer({
      metaNameTags: categoryMetaTags.metaNameTags,
      linkTags: categoryMetaTags.linkTags,
    }),
  )
}
